import { render, staticRenderFns } from "./practice.vue?vue&type=template&id=797c3ca4&scoped=true&"
import script from "./practice.vue?vue&type=script&lang=js&"
export * from "./practice.vue?vue&type=script&lang=js&"
import style0 from "./practice.vue?vue&type=style&index=0&id=797c3ca4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797c3ca4",
  null
  
)

export default component.exports